import { useState } from 'react';

import { postBookings } from '../../api/bookings';

export function usePostBookingCampRequest(
  campId: number,
  kidsIds: number[],
  isCareCreditUsed: boolean,
  eventHandlers: {
    onUrlResponse: (url: string) => void;
    onCheckoutResponse: (response: {
      careCreditBalance: number;
      checkoutId: string;
    }) => void;
    onNotEnoughCapacity: () => void;
    onError?: (error: Error) => void;
  }
) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const makeRequest = async () => {
    try {
      setIsSubmitting(true);
      const response = await postBookings({
        camp_id: campId,
        useCareCredit: isCareCreditUsed,
        children: kidsIds,
        bookingMode: 'camp',
      });

      if ('url' in response) {
        // redirect to stripe
        eventHandlers.onUrlResponse(response.url);
        return;
      }

      setIsSubmitting(false);
      if ('code' in response && response.code === 'NOT_ENOUGH_CAPACITY') {
        eventHandlers.onNotEnoughCapacity();
      } else if ('checkoutId' in response) {
        eventHandlers.onCheckoutResponse(response);
      }
    } catch (err) {
      setIsSubmitting(false);
      eventHandlers.onError?.(err as Error);
      alert('Failed to create booking. Try again later.');
    }
  };

  return { isSubmitting, makeRequest };
}
